'use strict';

import HealthThresholds from '@/classes/HealthThresholds';
import { BP_HEALTH_THRESHOLDS } from '@/constants/businessProcess/constants';

const availableBusinessProcesses = state => [...state.availableBusinessProcesses];

const supervisedBusinessProcesses = state => [...state.supervisedBusinessProcesses];

const businessProcessHealthConfigurationTemplates = state => [...state.businessProcessHealthConfigurationTemplates];

const getBusinessProcessHealthConfiguration = state => businessProcessId => {
  return state.businessProcessHealthConfigurations.find(
    configuration => configuration.businessProcessId === businessProcessId
  );
};

const getPreConfiguredBusinessProcessHealthThresholds = state => businessProcessId => {
  return state.businessProcessHealthThresholds
    .filter(item => item.businessProcessId === businessProcessId)
    .map(item => {
      item.name = item.name || BP_HEALTH_THRESHOLDS.customName;
      return new HealthThresholds(item);
    });
};

const getBusinessProcessHealthThresholds = state => businessProcessId => {
  return state.businessProcessHealthThresholds
    .filter(item => item.businessProcessId === businessProcessId)
    .map(item => {
      item.name = item.name || BP_HEALTH_THRESHOLDS.customName;
      return new HealthThresholds(item);
    });
};

const getActiveBusinessProcessHealthThreshold = (state, getters) => businessProcessId => {
  const active = state.businessProcessHealthThresholds.find(
    item => item.businessProcessId === businessProcessId && item.active
  );
  return active ? new HealthThresholds(active) : getters.getDefaultBusinessProcessHealthThreshold(businessProcessId);
};

const getDefaultBusinessProcessHealthThreshold = state => businessProcessId => {
  if (!state.businessProcessHealthThresholds.length) {
    return null;
  }

  const defaultHealthThreshold = state.businessProcessHealthThresholds.find(
    item => item.businessProcessId === businessProcessId && item.name === BP_HEALTH_THRESHOLDS.defaultName
  );
  return defaultHealthThreshold ? new HealthThresholds(defaultHealthThreshold) : null;
};

const getDefaultBusinessProcessHealthThresholds = state => {
  return [
    {
      id: 'businessProcessServiceLevel',
      warning: 80,
      danger: 70
    },
    {
      id: 'businessProcessAbandonedPercentage',
      warning: 3,
      danger: 5
    },
    {
      id: 'businessProcessWaitingInteractions',
      warning: 5,
      danger: 10
    },
    {
      id: 'businessProcessLongestWaitingTime',
      warning: '00:02:00',
      danger: '00:05:00'
    },
    {
      id: 'businessProcessAverageAnswerTime',
      warning: '00:00:30',
      danger: '00:01:00'
    },
    {
      id: 'businessProcessAverageAgentHandlingTime',
      warning: '00:05:00',
      danger: '00:10:00'
    }
  ];
};

const getBusinessProcessById = state => businessProcessId => {
  return state.availableBusinessProcesses.find(bp => {
    return bp.id === businessProcessId;
  });
};

export default {
  availableBusinessProcesses,
  supervisedBusinessProcesses,
  businessProcessHealthConfigurationTemplates,
  getPreConfiguredBusinessProcessHealthThresholds,
  getBusinessProcessHealthConfiguration,
  getActiveBusinessProcessHealthThreshold,
  getDefaultBusinessProcessHealthThreshold,
  getBusinessProcessHealthThresholds,
  getDefaultBusinessProcessHealthThresholds,
  getBusinessProcessById
};
